// extracted by mini-css-extract-plugin
module.exports = {"nowrapContainer":"TimerStandardFormat_nowrapContainer__1RVmq","sameSizeDigits":"TimerStandardFormat_sameSizeDigits__1h-bF"};